module.exports = __webpack_public_path__ + "img/selected3-min.c7b7e2d0.png";